/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";
import CustomTooltip from "../../../../../../../../components/CustomTooltip";
import {EMPTY_VALUES} from "../../../../../../../../Apis/functions";

/**
 * Value of a section preceded by its icon, truncated to a single row.
 */
const IconTextRow = ({Icon, text, className = ''}) => {
    return (
        <div className={`d-flex flex-grow-1 minw-0 align-items-center ${className}`}>
            <div className={'mr-2 d-flex align-items-center'}>
                <Icon/>
            </div>
            <div className={'flex-grow-1 minw-0'}>
                <CustomTooltip
                    text={text || EMPTY_VALUES.DEFAULT}
                    classes={'fs-14px font-color-general-950 text-ellipsis-1-row'}
                    showIfTruncated={true}
                />
            </div>
        </div>
    );
};

export default IconTextRow;
